import { Trans } from '@lingui/react/macro';
import { intacctUrls } from '@web/config/env';
import Box from 'carbon-react/lib/components/box';
import Button from 'carbon-react/lib/components/button';
import Dialog from 'carbon-react/lib/components/dialog';
import Form from 'carbon-react/lib/components/form';
import Heading from 'carbon-react/lib/components/heading';
import Typography from 'carbon-react/lib/components/typography';
import type { ComponentPropsWithoutRef } from 'react';
import styled from 'styled-components';

const StyledDialog = styled(Dialog)`
  & [data-component='dialog'] {
     & > div:first-child {
        padding-left: 0;
        padding-top: 0;
        padding-bottom: 0;
        border-radius: 16px;
        & > div:first-child {
            padding-top: 0;
        }
     }
  }
`;

export interface JoinUsModalProps extends ComponentPropsWithoutRef<typeof Dialog> {
  onRemindMeLater: (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement, MouseEvent>) => void;
  onOk: (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement, MouseEvent>) => void;
}

export function JoinUsDialogContent({ onRemindMeLater, onOk, ...dialogProps }: JoinUsModalProps) {
  return (
    <StyledDialog {...dialogProps}>
      <Box display="flex" flexDirection="row" maxHeight="332px">
        <Box>
          <img
            // Avoided multiple buckets since this is a temp component
            style={{ height: '332px' }}
            src="https://qa-sit-assets-public.s3.eu-west-1.amazonaws.com/images/join-us.png"
            alt="Join us in Sage Intacct"
          />
        </Box>
        <Form
          rightSideButtons={
            <Box display="flex" gap={2}>
              <Button buttonType="secondary" onClick={onRemindMeLater}>
                <Trans>Remind me later</Trans>
              </Button>
              <Button buttonType="primary" onClick={onOk}>
                <Trans>Got it</Trans>
              </Button>
            </Box>
          }
        >
          <Box pl={4} pt={2}>
            <Heading title="Notice: Access Sage Intelligent Time from Sage Intacct" divider={false} />
            <Box pt={2}>
              <Typography>
                The standalone version of Sage Intelligent Time was officially retired on <strong>September 30, 2025</strong>.
              </Typography>
              <Typography mb={0}>
                To ensure uninterrupted access, please transition to the embedded experience within{' '}
                <a target="_blank" rel="noreferrer" href={intacctUrls.login}>
                  Sage Intacct
                </a>{' '}
                by <strong>October 10, 2025</strong>. Going forward, Sage Intelligent Time must be accessed directly from within{' '}
                <a target="_blank" rel="noreferrer" href={intacctUrls.login}>
                  Sage Intacct
                </a>
                .
              </Typography>
            </Box>
          </Box>
        </Form>
      </Box>
    </StyledDialog>
  );
}
